module.exports = "query Letter ($id: String!) {\n  letter (id: $id) {\n    id\n    link\n\n    user_name\n    user_document\n    user_number\n    user_email\n\n    campaign {\n      partner {\n        id\n      }\n    }\n    letter {\n      logo\n      description\n      stamp\n      signature_image\n      signature_text\n    }\n  }\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/queries/Letter.graphql
// module id = 1881
// module chunks = 1610